<template>
  <section :class="isRouteLogin ? 'login' : 'layout'">
    <PageHeader />
    <main :class="isRouteLogin ? 'login-fields' : 'main-content'">
      <TolErrors />
      <TolMessages />
      <UpdateModal
        v-if="firstTimeApplicationAccess"
        :message="$t('components.updateModal.firstApplicationAccess')"
        :logo="true"
        :welcome="true"
        @continue-action="resetFirstTimeAccess()"
      >
      </UpdateModal>

      <UpdateModal
        v-if="isAccountVerificationRequired"
        :highlight="$t('components.updateModal.accountUser', { firstname })"
        :logo="true"
        :message="$t('components.updateModal.accountNotVerified')"
      >
        <template v-slot:modalData>
          <QuickLoginInput :user-name="accountVerificationUser" />
        </template>
      </UpdateModal>

      <ConfirmModal
        v-if="showResetTokenModal"
        title="Continue Session"
        action="selectedBulkAction"
        @continue-action="doResetToken()"
        @cancel-action="doCancel()"
      >
        <template v-slot:modalMessage>
          This session is about to expire. Would you like to continue?
        </template>
      </ConfirmModal>
      <router-view />
    </main>
    <PageFooter :class="isRouteLogin ? 'login-footer' : ''" />
  </section>
</template>

<script>
import PageFooter from './components/PageFooter';
import PageHeader from './components/PageHeader';
import TolErrors from './features/tol-errors/TolErrors';
import TolMessages from './features/tol-messages/TolMessages';
import ConfirmModal from '@/app/components/ConfirmModal';
import UpdateModal from '@/app/components/UpdateModal';
import { AppGetters, AppActions } from '@/app/app.keys';
import QuickLoginInput from '@/app/components/QuickLoginInput';

export default {
  name: 'App',
  components: {
    PageFooter,
    PageHeader,
    TolErrors,
    TolMessages,
    ConfirmModal,
    UpdateModal,
    QuickLoginInput
  },
  data() {
    return {
      isRouteLogin: false
    };
  },
  computed: {
    showResetTokenModal() {
      return this.$store.getters[AppGetters.RefreshTokenModalIsVisible];
    },
    firstTimeApplicationAccess() {
      return this.$store.getters[AppGetters.FirstTimeApplicationAccess];
    },
    isAccountVerificationRequired() {
      return this.$store.getters[AppGetters.AccountVerificationRequired];
    },
    accountVerificationUser() {
      return this.$store.getters[AppGetters.AccountVerificationUser];
    },
    firstname() {
      return this.$store.getters[AppGetters.AccountVerificationUserFirstname];
    }
  },
  watch: {
    $route(to) {
      this.isRouteLogin = to.name === 'login';
    }
  },
  updated() {
    const FIFTY_FIVE_MINUTES_INTO_MILLI_SECONDS = 3300000;
    if (this.$store.state.currentUser) {
      //this.isRecentUser = false
      //this.$store.dispatch(AppActions.SetRefreshTokenModalIsVisible, false);
      //called five minutes before session is about to expire
      //replace existing token with new token which has updated expiry date
      this.$store.dispatch(
        AppActions.InsertTimeOutReferences,
        setTimeout(() => {
          this.$store.dispatch(AppActions.SetRefreshTokenModalIsVisible, true);
        }, FIFTY_FIVE_MINUTES_INTO_MILLI_SECONDS)
      );
      this.$store.dispatch(AppActions.SetSessionRefreshTime, FIFTY_FIVE_MINUTES_INTO_MILLI_SECONDS);
      this.inactivityTime();
    }
  },
  methods: {
    resetFirstTimeAccess() {
      this.$store.dispatch(AppActions.SetFirstTimeApplicationAccess, false);
    },
    doResetToken() {
      this.$store.dispatch(AppActions.RefreshSession);
    },
    async doCancel() {
      this.$store.dispatch(AppActions.ResetSessionInactiveTime);
      this.$store.dispatch(AppActions.SetRefreshTokenModalIsVisible, false);
      window.onload = null;
      document.onmousemove = null;
      document.onkeydown = null;
      await this.$store.dispatch(AppActions.DismissSession);
      this.$router.push('/login');
    },
    inactivityTime() {
      window.onload = this.resetTimer;
      document.onmousemove = this.resetTimer;
      document.onkeydown = this.resetTimer;
    },
    resetTimer() {
      this.$store.dispatch(AppActions.UpdateLastActiveTime);
    }
  }
};
</script>

<style lang="scss">
@import 'styles/variables';
@import 'styles/colors';
@import 'styles/defaults';

.layout {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.main-content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 0;
  background-color: $background-level-1;
  margin: 0 auto 20px auto;

  width: $main-content-width;
}
.login {
  background: url('../../public/images/timeonline_bkrnd.webp');
  background-repeat: repeat-y;
  height: 100%;

  .login-fields {
    background-color: $background-level-1;
    width: 350px;
    display: flex;
    margin: auto;
  }
}

@media print {
  .layout {
    background: $white;
  }

  .main-content {
    background-color: $white;
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>
